var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _circle3, _path16, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrincess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "princess_svg__Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.27 165.92"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".princess_svg__cls-1{fill:#fcde09}.princess_svg__cls-2{fill:#fdf4f4}.princess_svg__cls-3{fill:#9c9e9f}.princess_svg__cls-5,.princess_svg__cls-7{fill:#c6d2d3}.princess_svg__cls-8{fill:#249cd3}.princess_svg__cls-9{fill:#343a40}.princess_svg__cls-7{stroke:#000;stroke-miterlimit:10;stroke-width:4px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-1",
    cx: 82.63,
    cy: 83.29,
    r: 82.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-9",
    d: "M153.96 66.9v-9.14c0-2.95-2.39-5.34-5.34-5.34H98.55c-2.95 0-5.34 2.39-5.34 5.34v9.14c0 .98.8 1.78 1.78 1.78h57.19c.98 0 1.78-.8 1.78-1.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-9",
    d: "M148.62 52.42h-25.04v16.26h28.6c.98 0 1.78-.8 1.78-1.78v-9.14c0-2.95-2.39-5.34-5.34-5.34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-3",
    d: "M93.21 66.9v40.94c0 2.94 2.4 5.34 5.34 5.34h50.07c2.94 0 5.34-2.4 5.34-5.34V66.9H93.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-3",
    d: "M123.58 113.17h25.04c2.94 0 5.34-2.4 5.34-5.34V66.89h-30.38v46.27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-5",
    d: "M146.84 75.8c0-.98-.8-1.78-1.78-1.78h-42.95c-.98 0-1.78.8-1.78 1.78v28.48c0 .98.8 1.78 1.78 1.78h42.95c.98 0 1.78-.8 1.78-1.78V75.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-5",
    d: "M145.06 74.02h-21.48v32.04h21.48c.98 0 1.78-.8 1.78-1.78v-7.71l-1.31-1.66 1.31-1.9v-17.2c0-.98-.8-1.78-1.78-1.78z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-2",
    d: "M116.46 106.05c-2.52 0-4.83-1.39-6.51-3.92-1.54-2.31-2.38-5.34-2.38-8.54s.85-6.23 2.38-8.54c1.69-2.53 4-3.92 6.51-3.92s4.83 1.39 6.51 3.92c1.54 2.31 2.38 5.34 2.38 8.54s-.85 6.23-2.38 8.54c-1.69 2.53-4 3.92-6.51 3.92z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-3",
    d: "M123.58 106.05c-2.52 0-4.83-1.39-6.51-3.92-1.54-2.31-2.38-5.34-2.38-8.54s.85-6.23 2.38-8.54c1.69-2.53 4-3.92 6.51-3.92s4.83 1.39 6.51 3.92c1.54 2.31 2.38 5.34 2.38 8.54s-.85 6.23-2.38 8.54c-1.69 2.53-4 3.92-6.51 3.92z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-3",
    d: "M130.1 85.06c-1.69-2.53-4-3.92-6.51-3.92v24.92c2.52 0 4.83-1.39 6.51-3.92 1.54-2.31 2.38-5.34 2.38-8.54s-.85-6.23-2.38-8.54z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-2",
    d: "M130.7 106.05c-2.52 0-4.83-1.39-6.51-3.92-1.54-2.31-2.38-5.34-2.38-8.54s.85-6.23 2.38-8.54c1.69-2.53 4-3.92 6.51-3.92s4.83 1.39 6.51 3.92c1.54 2.31 2.38 5.34 2.38 8.54s-.85 6.23-2.38 8.54c-1.69 2.53-4 3.92-6.51 3.92z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-2",
    d: "M137.22 102.13c1.54-2.31 2.38-5.34 2.38-8.54s-.85-6.23-2.38-8.54c-1.69-2.53-4-3.92-6.51-3.92s-4.83 1.39-6.51 3.92c-.22.32-.42.66-.6 1.01v15.05c.19.35.39.69.6 1.01 1.69 2.53 4 3.92 6.51 3.92s4.83-1.39 6.51-3.92z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-1",
    d: "M105.67 61.44h-3.56c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78h3.56c.98 0 1.78.8 1.78 1.78s-.8 1.78-1.78 1.78zM116.34 61.44h-3.56c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78h3.56c.98 0 1.78.8 1.78 1.78s-.8 1.78-1.78 1.78z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-9",
    d: "M145.06 72.24h-42.95c-1.96 0-3.56 1.6-3.56 3.56v28.48c0 1.96 1.6 3.56 3.56 3.56h42.95c1.96 0 3.56-1.6 3.56-3.56V75.8c0-1.96-1.6-3.56-3.56-3.56zm0 3.56V93h-42.95V75.8h42.95zm-42.95 28.48v-7.71h42.95v7.71h-42.95z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-9",
    d: "M145.06 72.24h-21.48v3.56h21.48V93h-21.48v3.56h21.48v7.71h-21.48v3.56h21.48c1.96 0 3.56-1.6 3.56-3.56V75.79c0-1.96-1.6-3.56-3.56-3.56z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-7",
    d: "M60.33 28.6c-13.85 0-25.06 11.21-25.06 25.06s11.21 25.06 25.06 25.06 25.06-11.21 25.06-25.06S74.18 28.6 60.33 28.6zM70.08 85.65H50.56c-19.65 0-35.61 15.96-35.61 35.61v14.51c0 2.24 1.71 3.96 3.96 3.96h82.82c2.24 0 3.96-1.71 3.96-3.96v-14.51c0-19.65-15.96-35.61-35.61-35.61z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-9",
    cx: 51.59,
    cy: 48.61,
    r: 3.02
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-9",
    cx: 69.06,
    cy: 48.61,
    r: 3.02
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 59.86c0 10.89 20.22 10.89 20.22 0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "#c6d2d3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 44.8,
    cy: 86.34,
    r: 3.92
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 77.66,
    cy: 86.83,
    r: 3.92
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 50.25,
    cy: 92.01,
    r: 3.92
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 57.4,
    cy: 95.33,
    r: 3.92
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 72.21,
    cy: 92.47,
    r: 3.92
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "princess_svg__cls-8",
    cx: 65.09,
    cy: 95.62,
    r: 3.92
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M69.77 22.41L59.5 3.73 49.23 22.41l-4.09 14.17 34.41-1.09 5.17-22.42-14.95 9.34z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M34.28 13.07l5.6 24.29h39.23l.43-1.87H48.69l.53-5.09v-7.98l-14.95-9.34z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M38.01 13.07c0 .67-.18 1.31-.49 1.85-.64 1.13-1.86 1.56-3.25 1.56-2.06 0-3.28-1.35-3.28-3.41 0-1.39.31-2.61 1.44-3.25a3.74 3.74 0 015.59 3.25z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M35.68 15.4a3.74 3.74 0 01-3.25-5.59 3.74 3.74 0 105.1 5.1c-.54.31-1.18.49-1.85.49zM63.23 3.74c0 .67-.18 1.31-.49 1.85-.64 1.13-1.86 1.56-3.25 1.56-2.06 0-3.28-1.35-3.28-3.41 0-1.39.31-2.61 1.44-3.25a3.74 3.74 0 015.59 3.25z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M60.9 6.07A3.74 3.74 0 0157.65.48a3.74 3.74 0 105.1 5.1c-.54.31-1.18.49-1.85.49zM88.45 13.07c0 .67-.18 1.31-.49 1.85-.64 1.13-1.86 1.56-3.25 1.56-2.06 0-3.28-1.35-3.28-3.41 0-1.39.31-2.61 1.44-3.25a3.74 3.74 0 015.59 3.25z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-8",
    d: "M86.12 15.4a3.74 3.74 0 01-3.25-5.59 3.74 3.74 0 105.1 5.1c-.54.31-1.18.49-1.85.49z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.52 155.14c-.29 0-.59-.02-.89-.05-.36-.04-1.02-.06-1.9-.1-16.61-.81-34.32-3.17-39.66-14.59-7.37-15.74.21-38.42 1.1-40.95a7.99 7.99 0 0110.2-4.9 7.998 7.998 0 014.91 10.18c-1.68 4.85-5.61 20.56-1.72 28.89.45.66 3.95 4.32 25.95 5.39 1.33.06 2.2.11 2.88.18 4.39.49 7.56 4.44 7.07 8.83-.45 4.09-3.92 7.12-7.94 7.12z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "#9c9e9f"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.25 131.3h1.55a7.74 7.74 0 007.74-7.74c0-.86-.69-1.55-1.55-1.55h-5.42v-3.1h5.42c2.57 0 4.65 2.08 4.65 4.65 0 5.99-4.85 10.84-10.84 10.84h-4.65l3.1-3.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "princess_svg__cls-9",
    d: "M82.89 115.04c0 9.1-2.63 18-7.57 25.64l-.95 1.46v.77H54.24v-.77l-.95-1.46a47.215 47.215 0 01-7.57-25.64h37.16z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.89 142.14H45.73c0 1.71 1.39 3.1 3.1 3.1H79.8c1.71 0 3.1-1.39 3.1-3.1z"
  })));
}

export default SvgPrincess;